import * as React from 'react';

import { TableBody } from '../components/ui/table.js';

export function DimeTableBody({ ...props }: Readonly<React.ComponentProps<typeof TableBody>>) {
  return <TableBody {...props} />;
}
